import { CampaignComponentSetting } from "./CampaignComponentSetting";
import { isCampaignComponentVariable, } from "./CampaignComponentVariable";
import { createCampaignComponentSettings } from "../../setting/factory/createCampaignComponentSettings";
export const isCampaignComponentSocket = (setting) => {
    return setting instanceof CampaignComponentSocket;
};
const createCampaignComponentVariables = (responses, context) => {
    const output = [];
    const settings = createCampaignComponentSettings(responses, context);
    settings.forEach((setting) => {
        if (isCampaignComponentVariable(setting)) {
            output.push(setting);
        }
    });
    return output;
};
export class CampaignComponentSocket extends CampaignComponentSetting {
    constructor(response, context) {
        super(response, context);
        this.filters = response.filters;
        this.parameters = createCampaignComponentVariables(response.parameters, context);
    }
}
